export default __webpack_public_path__ + "static/media/picture_scroll2.f1c40d08.jpg";